import { useState, useEffect } from "react";
import { Gift } from "lucide-react";
import api from "../lib/api";
import ProfileCard from "../components/ProfileCard";
import TipModal from "../components/TipModal";

export default function Sponsor() {
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tipTarget, setTipTarget] = useState(null);

  useEffect(() => {
    api.get("/sponsor/families").then((r) => setFamilies(r.data.families || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="sponsor-page">
      <div className="mb-10 flex flex-col items-center text-center">
        <span className="font-mono text-xs uppercase tracking-widest text-copper flex items-center gap-1.5">
          <Gift className="w-3.5 h-3.5" /> Season of Giving
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold text-bronze mt-2">Sponsor a Family this Christmas 🎄</h1>
        <div className="w-20 h-1 bg-gradient-to-r from-copper via-penny to-sage rounded-full my-3 opacity-90" />
        <p className="text-muted-foreground max-w-2xl leading-relaxed">
          Every family here has been personally verified by our team. Some we've quietly taken <b className="text-penny">under our wing</b> —
          real, truly in need, and kept private out of love for their children. This holiday, you can help carry one of them through.
          No judgment, no shame — just neighbours looking after neighbours. 🤍
        </p>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {Array.from({ length: 8 }).map((_, i) => <div key={i} className="h-64 rounded-2xl bg-secondary animate-pulse" />)}
        </div>
      ) : families.length === 0 ? (
        <p className="text-center text-muted-foreground py-20">No families to sponsor just yet — check back soon. 💛</p>
      ) : (
        <div data-testid="sponsor-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {families.map((p) => <ProfileCard key={p.user_id} profile={p} onTip={setTipTarget} />)}
        </div>
      )}

      <TipModal open={!!tipTarget} onClose={() => setTipTarget(null)} mode="individual" recipient={tipTarget} />
    </div>
  );
}
